


import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { FaArrowAltCircleDown } from 'react-icons/fa';
import heroImage from '../../../../../Assets/Mes/what is mes.png'; 
import { ToastContainer, toast } from 'react-toastify';
const WhatIsMes = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '' });

  const SERVER_ENDPOINT = 'https://api.kapiltech.com/api/mes/downloadDummies'; // replace with your endpoint
  const DRIVE_DOWNLOAD_URL = 'https://drive.google.com/file/d/1qOOYpO2FuLQLYQosRtE4fQy9bjdYPDpw/view?usp=sharing'; // replace with actual Drive URL

  const openModal = (e) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };



   const handleSubmit = async (e) => {
    e.preventDefault();

    try {
     

       toast.info( 'please wait your download is getting ready !', {
       
        autoClose: 3000,
       });
      
      const response = await axios.post(
        SERVER_ENDPOINT,
        { name: formData.name, email: formData.email }
      );

      // 2) clear your form
      setFormData({ name: '', email: '' });

      // 3) show toast from the returned message (or fallback)
      toast.success(response.data|| 'Download started!', {
        // position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });

      // 4) actually open your Drive URL in a new tab
      window.open(DRIVE_DOWNLOAD_URL, '_blank');

      // 5) then close the modal if you like
      closeModal();
    } catch (err) {
      console.error('Submission error:', err);
      toast.error(
        err.response?.data?.error || 'Something went wrong, please try again',
        { position: toast.POSITION.TOP_RIGHT, autoClose: 3000 }
      );
    }
  };
  return (
    <section className="bg-[#ebeaea] text-[#0D1B2A]">
      {/* Hero Content */}
       <ToastContainer />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row items-center lg:items-stretch py-12 lg:py-24">
        {/* Image Section (Left) */}
        <div className="w-full lg:w-1/2 flex justify-center mb-8 lg:mb-0">
          <div className="relative">
            <div className="hidden lg:block absolute inset-y-0 left-0 w-full">
              <svg
                className="absolute top-1/4 left-1/4 transform -translate-x-1/2 -translate-y-1/2"
                width="200"
                height="200"
                viewBox="0 0 100 100"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 0 L100 50 L20 100"
                  stroke="#00D8CA"
                  strokeWidth="20"
                  fill="none"
                />
              </svg>
            </div>
            <img
              src={heroImage}
              alt="Hero"
              className="relative max-w-xs sm:max-w-sm md:max-w-md lg:max-w-full "
            />
          </div>
        </div>

        {/* Text Section (Right) */}
        <div className="w-full lg:w-1/2 lg:pl-12">
          <h1 className="text-2xl sm:text-2xl lg:text-3xl font-bold leading-tight text-[#0D1B2A]">
            Infor™ MES: Real-Time Orchestration for Smart Factories
          </h1>
          <p className="mt-4 text-base sm:text-lg text-[#242e87]">
                 Infor MES is designed to revolutionize your manufacturing operations by providing real-time visibility and control over plant workflows. 

          </p>
          <p className="mt-4 text-base sm:text-lg text-[#0D1B2A]">
            By automating data collection and leveraging cloud-based analytics,  MES enhances operational efficiency across the global production networks. Discover how this adaptable and innovative MES can transforming your shop floor into a hub of productivity and efficiency.
          </p>
          {/* Download EBook Link */}
          <Link
            to="#"
            onClick={openModal}
            className="inline-block mt-2 text-[#00A6B4] font-medium hover:underline"
          >
            Download EBook | MES for Dummies
            <FaArrowAltCircleDown className="inline ml-2" />
          </Link>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white text-black rounded-2xl p-6 w-11/12 max-w-md">
            <h2 className="text-xl font-semibold mb-4">Enter your details</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block mb-1" htmlFor="name">
                  Name
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                />
              </div>
              <div>
                <label className="block mb-1" htmlFor="email">
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                />
              </div>
              <div className="flex justify-end space-x-2">
                <button
                  type="button"
                  onClick={closeModal}
                  className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 rounded bg-[#00A6B4] text-white hover:bg-[#00838a]"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </section>
  );
};

export default WhatIsMes;
